// GoogleSheetsService.js
// Refactored: Calls backend API to fetch Google Sheets data using a service account

// Use the base URL from environment and append the REST endpoint
const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
const API_URL = `${BASE_URL.replace('/graphql', '')}/api/google-sheets/read`;

export async function fetchGoogleSheetData(url, options = {}) {
  const {
    timezone = null,
    dateFormat = 'auto',
    dateColumns = [],
    processDates = false,
  } = options;

  const response = await fetch(API_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      url,
      timezone,
      dateFormat,
      dateColumns,
      processDates,
    }),
    credentials: 'include',
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to fetch Google Sheet data');
  }
  return response.json();
}
